import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Drain',
    desc: 'Use the CNS Sweep to get every stressful thought out of your head and onto paper.'
  }, {
    num: '02',
    title: 'Design',
    desc: 'Use the Launch Map to set your Monday to "Default Easy."'
  }, {
    num: '03',
    title: 'Defend',
    desc: 'Use the Boundary Shield to pre-write your "No\'s" so you stay in control of your energy.'
  }];
  return <section className="bg-white py-20 md:py-28 px-6" data-id="element-108">
      <div className="max-w-reading mx-auto" data-id="element-109">
        <FadeIn data-id="element-110">
          <h2 className="text-3xl md:text-4xl font-serif text-forest mb-16 text-center" data-id="element-111">
            How it works
          </h2>

          <div className="space-y-12 relative before:absolute before:inset-0 before:ml-6 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-sage/10 before:via-sage/40 before:to-sage/10" data-id="element-112">
            {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-113">
                <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-114">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full border-4 border-white bg-cream text-forest font-serif text-xl z-10 shadow-sm md:mx-auto shrink-0" data-id="element-115">
                    {step.num}
                  </div>

                  <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] p-6 rounded-2xl bg-cream/30 border border-sage/10 hover:border-sage/30 transition-colors" data-id="element-116">
                    <h3 className="text-2xl font-serif text-forest mb-2" data-id="element-117">
                      {step.title}
                    </h3>
                    <p className="text-charcoal/80 font-light" data-id="element-118">{step.desc}</p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}